import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppConfigService } from '@core/appconfig.service';
import { translateHttpLoaderFactory } from '@core/core.module';
import { DefaultTranslationProvider } from '@core/default-translation.provider';
import { LOCALE_ROLE } from '@core/translate-api.loader';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@shared/button/button.component';
import { PreloaderModule } from '@shared/preloader/preloader.module';
import { SharedModule } from '@shared/shared.module';

import { ZbpIconComponent } from '@shared/zbp-icon/zbp-icon';
import { BrandedLoginComponent } from './branded-login/branded-login.component';
import { LoginFormComponent } from './branded-login/login-form/login-form.component';
import { BrandedQrCodeLoginComponent } from './branded-login/qr-code-aside/branded-qr-code-login.component';
import { SsoFormComponent } from './branded-login/sso-form/sso-form.component';
import {
  ChooseLoginRedesignHandlerComponent
} from './choose-login/choose-login-redesign-handler/choose-login-redesign-handler.component';
import { ChooseLoginComponent } from './choose-login/choose-login.component';
import {
  RedesignedChooseLoginComponent
} from './choose-login/redesigned-choose-login/redesigned-choose-login.component';
import { RoleButtonComponent } from './choose-login/redesigned-choose-login/role-button/role-button.component';
import {
  ForgotPasswordHandlerComponent
} from './forgot-password/forgot-password-handler/forgot-password-handler.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { InvalidTokenComponent } from './invalid-token/invalid-token.component';
import { LoginRoutingModule } from './login-routing.module';
import { LoginStudentHandlerComponent } from './login-student-handler/login-student-handler.component';
import { LoginUserHandlerComponent } from './login-user-handler/login-user-handler.component';
import { LoginComponent } from './login.component';
import { SkofLoginComponent } from './login.skof/login.skof.component';
import { LoginSsoComponent } from './login.sso/login.sso.component';
import { StudentLoginComponent } from './login.student/login.student.component';
import { TeacherLoginComponent } from './login.teacher/login.teacher.component';
import { LtiTokenExchangeComponent } from './lti-token-exchange/lti-token-exchange.component';
import { OAuth2Component } from './oauth2/oauth2.component';
import { SetupAccountHandlerComponent } from './setup-account-handler/setup-account-handler.component';
import { SetupAccountPasswordComponent } from './setup-account-password/setup-account-password.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ZbpIconComponent,
    ButtonComponent,
    PreloaderModule,
    LoginRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrandedQrCodeLoginComponent,
    TranslateModule.forChild({
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: DefaultTranslationProvider,
      },
      loader: {
        provide: TranslateLoader,
        useFactory: (translateHttpLoaderFactory),
        deps: [HttpClient, AppConfigService, LOCALE_ROLE],
      },
      isolate: true,
    }),
  ],
  declarations: [
    SkofLoginComponent,
    StudentLoginComponent,
    TeacherLoginComponent,
    ChooseLoginComponent,
    ChooseLoginRedesignHandlerComponent,
    RoleButtonComponent,
    RedesignedChooseLoginComponent,
    LoginComponent,
    SetupAccountPasswordComponent,
    InvalidTokenComponent,
    ForgotPasswordComponent,
    LtiTokenExchangeComponent,
    OAuth2Component,
    LoginSsoComponent,
    BrandedLoginComponent,
    SsoFormComponent,
    SetupAccountHandlerComponent,
    LoginUserHandlerComponent,
    LoginStudentHandlerComponent,
    ForgotPasswordHandlerComponent,
    LoginFormComponent,
  ],
  providers: [
    { provide: LOCALE_ROLE, useValue: null },
  ],
  exports: [
    SkofLoginComponent,
    StudentLoginComponent,
    TeacherLoginComponent,
    ChooseLoginComponent,
    LoginComponent,
    LoginSsoComponent,
    BrandedQrCodeLoginComponent,
  ]
})
export class LoginModule { }
